import React from "react";
import "./project.css";
import Spin from "react-reveal/Spin";

const projectData = [
  {
    title: "Food Order Website",
    imgSrc:
      "https://s3-alpha.figma.com/hub/file/1623354257/19135ea3-2504-4ad4-acea-5dad198e7a6c-cover.png",
    tags: ["Node", "Express", "React", "MongoDB"],
    link: "https://github.com/SHIVUKUMARA/food-order-website",
    badge: "Full Stack",
  },
  {
    title: "Blog Application",
    imgSrc:
      "https://www.shutterstock.com/image-photo/blog-blogging-homepage-social-media-600nw-381746308.jpg",
    tags: ["Node", "Express", "React", "MongoDB"],
    link: "https://github.com/SHIVUKUMARA/Blog-Application",
    badge: "Mern Stack",
  },
  {
    title: "Music player",
    imgSrc:
      "https://d1odn9376gg444.cloudfront.net/www.larkplayer.com/sites/170/2023/03/08064745/music-with-euqalizer.jpg",
    tags: ["Node", "Express", "React", "MongoDB"],
    link: "https://github.com/SHIVUKUMARA/Music-Player",
    badge: "Mern Stack",
  },
  {
    title: "News Application",
    imgSrc:
      "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcTkVqJ4_0gL-xkN85LyI7k4GXXDnBuTvWG--w&usqp=CAU",
    tags: ["React"],
    link: "https://github.com/SHIVUKUMARA/News-application",
    badge: "React",
  },
  {
    title: "Personal voice assistant",
    imgSrc:
      "https://e0.pxfuel.com/wallpapers/286/888/desktop-wallpaper-iron-man-jarvis-animated.jpg",
    tags: ["React"],
    link: "https://github.com/SHIVUKUMARA/personal-voice-assistant",
    badge: "React",
  },
  {
    title: "Library Management System",
    imgSrc:
      "https://images.pexels.com/photos/1370295/pexels-photo-1370295.jpeg?auto=compress&cs=tinysrgb&dpr=1&w=500",
    tags: ["Python"],
    link: "https://github.com/SHIVUKUMARA/Library-Management",
    badge: "Python",
  },
];

const Project = () => {
  return (
    <div className="container project" id="projects">
      <h2 className="col-12 mt-3 mb-1 text-center text-uppercase">
        Recent Projects
      </h2>
      <hr />
      <p className="pb-3 text-center">
        Developed a dynamic and responsive food order and Blog App platform
        using the MERN stack, seamlessly integrating MongoDB, Express, React,
        and Node.js for a user-friendly and proficiency in building scalable and
        interactive web applications. Engineered an efficient Python-based
        library management system, streamlining book tracking, user management,
        and lending processes, demonstrating expertise in Python programming.
      </p>

      {["ads"].map((id, index) => (
        <div key={index} className="row" id={id}>
          <Spin>
            {projectData.map((project, index) => (
              <div className="col-md-4" key={index}>
                <div className="card rounded">
                  <div className="card image">
                    <span className="card-notify-badge">{project.badge}</span>
                    <img src={project.imgSrc} alt={`project${index + 1}`} />
                  </div>
                  <div className="card-image-overlay m-auto mt-2">
                    {project.tags.map((tag, idx) => (
                      <span key={idx} className="card-detail-badge">
                        {tag}
                      </span>
                    ))}
                  </div>
                  <div className="card-body text-center">
                    <div className="ad-title m-auto">
                      <h5 className="text-uppercase">{project.title}</h5>
                    </div>
                    <a className="ad-btn" href={project.link} target="blank">
                      View
                    </a>
                  </div>
                </div>
              </div>
            ))}
          </Spin>
        </div>
      ))}
    </div>
  );
};

export default Project;
